var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBarChart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  "aria-hidden": "true",
  "data-icon": "bar-chart",
  viewBox: "64 64 896 896"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M120 840h784v64H120zm96-384h128v320H216zm232-160h128v480H448zm232-128h128v608H680z"
})));
export default SvgIconBarChart;